import { ArrayOperator, DateOperator, Operator } from '@inixiative/json-rules';

// gloss
export const OPERATOR_LABELS: Record<string, string> = {
  [Operator.equals]: 'equals',
  [Operator.notEquals]: 'does not equal',
  [Operator.greaterThan]: 'greater than',
  [Operator.greaterThanEquals]: 'greater than or equal to',
  [Operator.lessThan]: 'less than',
  [Operator.lessThanEquals]: 'less than or equal to',
  [Operator.contains]: 'contains',
  [Operator.notContains]: 'does not contain',
  [Operator.startsWith]: 'starts with',
  [Operator.endsWith]: 'ends with',
  [Operator.in]: 'is one of',
  [Operator.notIn]: 'is not one of',
  [Operator.matches]: 'matches pattern',
  [Operator.notMatches]: 'does not match pattern',
  [Operator.between]: 'is between',
  [Operator.notBetween]: 'is not between',
  [Operator.isEmpty]: 'is empty',
  [Operator.notEmpty]: 'is not empty',
  [Operator.exists]: 'exists',
  [Operator.notExists]: 'does not exist',
  [DateOperator.before]: 'is before',
  [DateOperator.after]: 'is after',
  [DateOperator.onOrBefore]: 'is on or before',
  [DateOperator.onOrAfter]: 'is on or after',
  [DateOperator.notBefore]: 'not before',
  [DateOperator.notAfter]: 'not after',
  [DateOperator.notWithin]: 'not within',
  [DateOperator.dayIn]: 'day is one of',
  [DateOperator.dayNotIn]: 'day is not one of',
  [ArrayOperator.all]: 'all match',
  [ArrayOperator.any]: 'any match',
  [ArrayOperator.none]: 'none match',
  [ArrayOperator.atLeast]: 'at least',
  [ArrayOperator.atMost]: 'at most',
  [ArrayOperator.exactly]: 'exactly',
  [ArrayOperator.empty]: 'is empty',
};
